import React from 'react';

import { connect } from 'react-redux';
import {createFilter} from 'react-search-input';
import { withLocalize } from "react-localize-redux";
import _ from 'lodash';

import { fetchEightDs } from '../../actions/eightD';
import EightDList from './EightDList';
import EightDSearch from './EightDSearch';




class EightD extends React.Component {

  constructor(props) {
    super(props);
    const { fetchEightDs } = this.props;
    fetchEightDs();
    this.state = {
      searchTerm: '',
      eightDs : [],
      sortBy : 'alphabetic',
      user: JSON.parse(localStorage.getItem("user")),
      selectedStartDates : [],
      selectedEndDates : [],
      validationFilter : 'all',
      selectedItems : {
        'information':{
          'program':[],
          'projectManager':[],
          'start-date':[],
          'end-date':[]
        },
        'client':{
          'level_1':[],
        },
        'environnement.environnement-domain':[],
        'environnement.environnement-context':[],
        'intervention-level':{
          'intervention-type':[],
          'intervention-mission':[],
          'intervention-application':[]
        },
        'expertise':{
          'domain-competence':[],
          'domain-speciality':[],
          'domain-specificity':[],
          'domain-other':[]
        },
      }
    }
  }

  componentDidMount(){
    var _this = this
    if(this.props.eightDs.length){
      this.setState({
        eightDs:_this.props.eightDs
      })
    }
  }

  componentDidUpdate(prevProps,prevState){
    var _this = this
    if(!prevProps.eightDs.length && this.props.eightDs.length){
      this.setState({
        eightDs:_this.props.eightDs
      })
    }
    if(prevState.validationFilter !== _this.state.validationFilter ){
      this.filterEightDs(this.state.selectedItems)
    }

  }

  setSort(data) {
    this.setState({
      sortBy:data
    })
  }

  setSelectedStartDates(data) {
    this.setState({
      selectedStartDates:data
    })
    this.filterEightDs(this.state.selectedItems, data, this.state.selectedEndDates)
  }

  setSelectedEndDates(data) {
    this.setState({
      selectedEndDates:data
    })
    this.filterEightDs(this.state.selectedItems, this.state.selectedStartDates, data)
  }

  selectItem(data) {

    var items = this.state.selectedItems
    if(data.parent === "environnement"){
      items[data.parent + "." + data.name] = data.value
    }
    else if(data.name){
      items[data.parent][data.name] = data.value
    }else{
      items[data.parent] = data.value
    }

    this.filterEightDs(items, this.state.selectedStartDates, this.state.selectedEndDates)
  }

  
  filterEightDs(items, selectedStartDates, selectedEndDates){
    var eightDs = this.props.eightDs



    _.forEach(items, function(parentItem, parentItemKey){

      if(Array.isArray(parentItem)){
        if(parentItem.length){
          eightDs = _.filter(eightDs, function(eightD){

            
            var mapEightD = eightD.aggregate[parentItemKey]

            return _.intersection(mapEightD, parentItem).length > 0
          })
        }
      }else{
        _.forEach(parentItem, function(item, itemKey){
          if(item.length){
            eightDs = _.filter(eightDs, function(eightD){
              var mapEightD = eightD.aggregate[parentItemKey]

              if(Array.isArray(mapEightD)){

                mapEightD = _.map(mapEightD, itemKey)

                return _.intersection(mapEightD, item).length > 0
              }else{
                if(Array.isArray(mapEightD[itemKey])){
                  return _.intersection(mapEightD[itemKey], item).length > 0
                }else{
                  return item.indexOf(eightD.aggregate[parentItemKey.toString()][itemKey.toString()]) !== -1
                }
              }

            })
          }
        })
      }
    })

    if(selectedStartDates && selectedStartDates.length > 0){
      eightDs = _.filter(eightDs, function(eightD){
        var startDate = selectedStartDates[0]
        var endDate = selectedStartDates[1]
        if(eightD.aggregate['information']['start-date']){
          var parseDate = eightD.aggregate['information']['start-date'].split('/')
          var parseStringDate = parseDate[2]+"-"+parseDate[1]+"-"+parseDate[0]
          return new Date(parseStringDate).getTime() >= new Date(startDate.date).getTime() && new Date(parseStringDate).getTime() <= new Date(endDate.date).getTime()
        }else{
          return false
        }
      })
    }

    if(selectedEndDates && selectedEndDates.length > 0){
      eightDs = _.filter(eightDs, function(eightD){
        var startDate = selectedEndDates[0]
        var endDate = selectedEndDates[1]
        if(eightD.aggregate['information']['end-date']){
          var parseDate = eightD.aggregate['information']['end-date'].split('/')
          var parseStringDate = parseDate[2]+"-"+parseDate[1]+"-"+parseDate[0]
          return new Date(parseStringDate).getTime() >= new Date(startDate.date).getTime() && new Date(parseStringDate).getTime() <= new Date(endDate.date).getTime()
        }else{
          return false
        }
      })
    }



    //filter by validation
    if (this.state.validationFilter === "validated"){
      eightDs = _.filter(eightDs, function(item){
        return item.validationInformation && item.validationInformation.isValidated;
      })
    }else if (this.state.validationFilter === "not validated"){
      eightDs = _.filter(eightDs, function(item){
        return !item.validationInformation || !item.validationInformation.isValidated;
      })
    }else{
      
    }

    this.setState({
      selectedItems:items,
      eightDs:eightDs
    })
  };

  searchUpdated = (term) => {
    this.setState({searchTerm: term})
  }

  renderEightDs() {
    if (this.state.eightDs && this.state.eightDs.length) {
      var eightDs = this.state.eightDs
      if(this.state.sortBy === 'alphabetic'){
        eightDs = _.sortBy(eightDs, function(eightD){
          return eightD.aggregate['information']['name']
        })
      }
      if(this.state.sortBy === 'startDate'){
        eightDs = _.sortBy(eightDs, function(eightD){
          var value = 0
          if(eightD.aggregate['information']['start-date']){
            var parseDate = eightD.aggregate['information']['start-date'].split('/')
            var parseStringDate = parseDate[2]+"-"+parseDate[1]+"-"+parseDate[0]
            value = new Date(parseStringDate).getTime()
          }
          if(isNaN(value)){
            value = 0
          }
          return value
        }).reverse()
      }
      if(this.state.sortBy === 'duration'){
        eightDs = _.sortBy(eightDs, function(eightD){
          var value = 0
          if(eightD.aggregate['information']['start-date'] && eightD.aggregate['information']['end-date']){
            var parseStart = eightD.aggregate['information']['start-date'].split('/');
            var parseStringStart = parseStart[2]+"-"+parseStart[1]+"-"+parseStart[0];
            var parseEnd = eightD.aggregate['information']['end-date'].split('/');
            var parseStringEnd = parseEnd[2]+"-"+parseEnd[1]+"-"+parseEnd[0];
            value = new Date(parseStringEnd).getTime() - new Date(parseStringStart).getTime()
          }
          if(isNaN(value)){
            value = 0
          }
          return value
        }).reverse()
      }
      if(this.state.sortBy === 'completion'){
        eightDs = _.sortBy(eightDs, function(eightD){
          return eightD.content.progression
        }).reverse()
      }
      const KEYS_TO_FILTERS = ['content.information.name']
      return (
        <EightDList circle={false} items={eightDs.filter(createFilter(this.state.searchTerm, KEYS_TO_FILTERS))} translate= {this.props.translate} endpoint= {"/8D/"}/>
      );
    }
  }


  selectValidationFilter(value){
    if (value === "all"){
      this.setState({
        validationFilter: "all"
      })
    }
    else if (value === "validated") {
      this.setState({
        validationFilter: "validated"
      })
    }
    else {
      this.setState({
        validationFilter: "not validated"
      })      
    }
  }



  render() {

    
    if (this.props.eightDs.length === 0) {
      return (
        <h3>Loading...</h3>
      )
    }

    var startDates = _.map(this.props.eightDs, function(eightD){
      if(eightD.aggregate['information']['start-date']){
        var parseDate = eightD.aggregate['information']['start-date'].split('/')
        var parseStringDate = parseDate[2]+"-"+parseDate[1]+"-"+parseDate[0]
        return parseStringDate
      }
      return
    })
    startDates = _.compact(startDates)
    startDates = _.uniq(startDates)
    startDates = _.map(startDates, function(date){
      return new Date(date)
    })
    startDates = _.orderBy(startDates, function(date){
      return date.getTime()
    })

    var startDate = startDates[0];
    var endDate = new Date();

    var getMonthArray = function(start, end) {
      var arr = new Array([]);
      var dt = new Date(start);
      while (dt <= end) {
        arr.push(new Date(dt));
        dt.setMonth(dt.getMonth() + 1);
      }
      return arr;
    }

    var dateArr = getMonthArray(startDate, endDate);

    dateArr = _.compact(_.map(dateArr, function(date){
      const parsedDate = new Date(date)
      let month = parsedDate.getMonth()+1
      if(parsedDate.getMonth() <9){
        month = "0"+(parsedDate.getMonth()+1)
      }
      const dateToReturn = month+"/"+parsedDate.getFullYear()
      if(dateToReturn !== "NaN/NaN"){
        return {
          date : parsedDate,
          dateLabel : dateToReturn
        }
      }
    }))

    return (
      <div>
        <div className="dashboard-header">
        <div style={{color:"red"}}>*Fonctionnalité en cours de développement</div>
        </div>
        {!this.state.eightDs || !this.state.eightDs.length ? (
          <div style={{left:'40%',right:'40%',top:'40%', bottom:'40%', display:'flex', position:'absolute', justifyContent:'center', alignItems:'center', flexDirection:'column'}}>
            <i className="fa fa-circle-notch fa-spin fa-3x" style={{color: '#eb4f1e'}}></i>
            <p style={{color:"#fff", marginTop:"10px", textAlign:'center'}}>Receiving 8Ds ...</p>
          </div>
        ) : (
          <>
            <EightDSearch
              searchUpdated={this.searchUpdated}
              eightDs={this.state.eightDs}
              selectedItems={this.props.selectedItems}
              selectItem={this.selectItem.bind(this)}
              setSort={this.setSort.bind(this)}
              setSelectedStartDates={this.setSelectedStartDates.bind(this)}
              setSelectedEndDates={this.setSelectedEndDates.bind(this)}
              dates={dateArr}
              selectValidationFilter = {this.selectValidationFilter.bind(this)}
            />

            <div className="page-container">
              {this.renderEightDs()}
            </div>
          </>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    eightDs: state.eightD.eightDs,
    eightD: state.eightD.eightD,
    message: state.eightD.message,
  };
}

export default connect(mapStateToProps, {fetchEightDs})(withLocalize(EightD));
